export const information_data = {
  bassInfo: [
    'From Daegu. South Korea.',
    'Living in Osaka. Japan.',
    '1988.10.26',
    'Email : rhapsodist.mk@gmail.com'
  ],
  career: [
    {
      date: `2020.01 - NOW`,
      title: `FreeLance`,
      country: `Japan`,
      infos: [
          `Full stack engineer`
      ]
    },
    {
      date: `2018.04 - 2020.01`,
      title: `Zen office Corporation`,
      country: `Japan`,
      infos: [
          `Full stack lead engineer`
      ]
    },
    {
      date: `2016.07 - 2017.12`,
      title: `FreeLance`,
      country: `Korea`,
      infos: [
          `Full stack engineer`
      ]
    },
    {
      date: `2016.07 - 2017.07`,
      title: `Asung Korea`,
      country: `Korea`,
      infos: [
          `Sales and Marketing`
      ]
    },
    {
      date: `2015.02 - 2015.06`,
      title: `Shunjie air express`,
      country: `China`,
      infos: [
          `Sales and Management intern`
      ]
    },
    {
      date: `2013.03 - 2014.12`,
      title: `Jiahe foreign language school`,
      country: `China`,
      infos: [
          `Korean & Chinese language teacher, translator`
      ]
    },
    {
      date: `2009.09 - 2011.07`,
      title: `Military service`,
      country: `Korea`,
      infos: [
          `The army`
      ]
    },
    {
      date: `2006.08 - 2009.06`,
      title: "Let`s Entertainment",
      country: `Korea`,
      infos: [
          `Magician & Sales Management`
      ]
    }
  ],
  education: [
    {
      date: `2011.09 - 2015.07`,
      title: `Dalian University`,
      country: `China`,
      infos: [
          `Trade & Commerce, Chinese language`
      ]
    },
    {
      date: `2007.03 - 2009.07`,
      title: `Dongyang University`,
      country: `Korea`,
      infos: [
          `Software(Computer) Engineering, Physics`
      ]
    },
  ],
  languages: [
    `korean`,
    `english`,
    `japanese`,
    `chinese`,
    `spanish`
  ],
  hobby: [
    `Playing Guitar`,
    `Learn new Languages`,
    `Playing Chess`,
    `Assembling things`,
    `Do Magic`,
  ]
}